export default __webpack_public_path__ + "static/media/(11).6e791325.jpg";